import Ie, { useState as Rr, useRef as br, useEffect as xr, Suspense as V } from "react";
import { ErrorBoundary as _r } from "react-error-boundary";
import { useTranslation as Fe } from "react-i18next";
import { useNavigate as jr, useRouteError as wr, isRouteErrorResponse as Tr } from "react-router-dom";
import { Box as z, Stack as ne, Alert as Cr, AlertTitle as Sr, Collapse as kr, Typography as K, Button as $, useTheme as Or } from "@mui/material";
import { HTTPError as Pr } from "ky";
var q = { exports: {} }, L = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pe;
function Ar() {
  if (Pe) return L;
  Pe = 1;
  var a = Ie, s = Symbol.for("react.element"), f = Symbol.for("react.fragment"), p = Object.prototype.hasOwnProperty, m = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, b = { key: !0, ref: !0, __self: !0, __source: !0 };
  function w(T, h, O) {
    var R, _ = {}, C = null, Y = null;
    O !== void 0 && (C = "" + O), h.key !== void 0 && (C = "" + h.key), h.ref !== void 0 && (Y = h.ref);
    for (R in h) p.call(h, R) && !b.hasOwnProperty(R) && (_[R] = h[R]);
    if (T && T.defaultProps) for (R in h = T.defaultProps, h) _[R] === void 0 && (_[R] = h[R]);
    return { $$typeof: s, type: T, key: C, ref: Y, props: _, _owner: m.current };
  }
  return L.Fragment = f, L.jsx = w, L.jsxs = w, L;
}
var W = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ae;
function Dr() {
  return Ae || (Ae = 1, process.env.NODE_ENV !== "production" && (function() {
    var a = Ie, s = Symbol.for("react.element"), f = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), m = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), w = Symbol.for("react.provider"), T = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), O = Symbol.for("react.suspense"), R = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), Y = Symbol.for("react.offscreen"), oe = Symbol.iterator, We = "@@iterator";
    function $e(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = oe && e[oe] || e[We];
      return typeof r == "function" ? r : null;
    }
    var P = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        Ye("error", e, t);
      }
    }
    function Ye(e, r, t) {
      {
        var n = P.ReactDebugCurrentFrame, l = n.getStackAddendum();
        l !== "" && (r += "%s", t = t.concat([l]));
        var c = t.map(function(u) {
          return String(u);
        });
        c.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, c);
      }
    }
    var Be = !1, Me = !1, Ne = !1, Ue = !1, Ve = !1, ie;
    ie = Symbol.for("react.module.reference");
    function qe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === p || e === b || Ve || e === m || e === O || e === R || Ue || e === Y || Be || Me || Ne || typeof e == "object" && e !== null && (e.$$typeof === C || e.$$typeof === _ || e.$$typeof === w || e.$$typeof === T || e.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ie || e.getModuleId !== void 0));
    }
    function Je(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var l = r.displayName || r.name || "";
      return l !== "" ? t + "(" + l + ")" : t;
    }
    function se(e) {
      return e.displayName || "Context";
    }
    function j(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case p:
          return "Fragment";
        case f:
          return "Portal";
        case b:
          return "Profiler";
        case m:
          return "StrictMode";
        case O:
          return "Suspense";
        case R:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case T:
            var r = e;
            return se(r) + ".Consumer";
          case w:
            var t = e;
            return se(t._context) + ".Provider";
          case h:
            return Je(e, e.render, "ForwardRef");
          case _:
            var n = e.displayName || null;
            return n !== null ? n : j(e.type) || "Memo";
          case C: {
            var l = e, c = l._payload, u = l._init;
            try {
              return j(u(c));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var S = Object.assign, I = 0, ue, le, ce, fe, de, ve, pe;
    function me() {
    }
    me.__reactDisabledLog = !0;
    function ze() {
      {
        if (I === 0) {
          ue = console.log, le = console.info, ce = console.warn, fe = console.error, de = console.group, ve = console.groupCollapsed, pe = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: me,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        I++;
      }
    }
    function Ke() {
      {
        if (I--, I === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: S({}, e, {
              value: ue
            }),
            info: S({}, e, {
              value: le
            }),
            warn: S({}, e, {
              value: ce
            }),
            error: S({}, e, {
              value: fe
            }),
            group: S({}, e, {
              value: de
            }),
            groupCollapsed: S({}, e, {
              value: ve
            }),
            groupEnd: S({}, e, {
              value: pe
            })
          });
        }
        I < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G = P.ReactCurrentDispatcher, H;
    function B(e, r, t) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (l) {
            var n = l.stack.trim().match(/\n( *(at )?)/);
            H = n && n[1] || "";
          }
        return `
` + H + e;
      }
    }
    var X = !1, M;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      M = new Ge();
    }
    function he(e, r) {
      if (!e || X)
        return "";
      {
        var t = M.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      X = !0;
      var l = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var c;
      c = G.current, G.current = null, ze();
      try {
        if (r) {
          var u = function() {
            throw Error();
          };
          if (Object.defineProperty(u.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(u, []);
            } catch (E) {
              n = E;
            }
            Reflect.construct(e, [], u);
          } else {
            try {
              u.call();
            } catch (E) {
              n = E;
            }
            e.call(u.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (E) {
            n = E;
          }
          e();
        }
      } catch (E) {
        if (E && n && typeof E.stack == "string") {
          for (var o = E.stack.split(`
`), y = n.stack.split(`
`), d = o.length - 1, v = y.length - 1; d >= 1 && v >= 0 && o[d] !== y[v]; )
            v--;
          for (; d >= 1 && v >= 0; d--, v--)
            if (o[d] !== y[v]) {
              if (d !== 1 || v !== 1)
                do
                  if (d--, v--, v < 0 || o[d] !== y[v]) {
                    var x = `
` + o[d].replace(" at new ", " at ");
                    return e.displayName && x.includes("<anonymous>") && (x = x.replace("<anonymous>", e.displayName)), typeof e == "function" && M.set(e, x), x;
                  }
                while (d >= 1 && v >= 0);
              break;
            }
        }
      } finally {
        X = !1, G.current = c, Ke(), Error.prepareStackTrace = l;
      }
      var D = e ? e.displayName || e.name : "", k = D ? B(D) : "";
      return typeof e == "function" && M.set(e, k), k;
    }
    function He(e, r, t) {
      return he(e, !1);
    }
    function Xe(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function N(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return he(e, Xe(e));
      if (typeof e == "string")
        return B(e);
      switch (e) {
        case O:
          return B("Suspense");
        case R:
          return B("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case h:
            return He(e.render);
          case _:
            return N(e.type, r, t);
          case C: {
            var n = e, l = n._payload, c = n._init;
            try {
              return N(c(l), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var F = Object.prototype.hasOwnProperty, ge = {}, ye = P.ReactDebugCurrentFrame;
    function U(e) {
      if (e) {
        var r = e._owner, t = N(e.type, e._source, r ? r.type : null);
        ye.setExtraStackFrame(t);
      } else
        ye.setExtraStackFrame(null);
    }
    function Ze(e, r, t, n, l) {
      {
        var c = Function.call.bind(F);
        for (var u in e)
          if (c(e, u)) {
            var o = void 0;
            try {
              if (typeof e[u] != "function") {
                var y = Error((n || "React class") + ": " + t + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw y.name = "Invariant Violation", y;
              }
              o = e[u](r, u, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (d) {
              o = d;
            }
            o && !(o instanceof Error) && (U(l), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, u, typeof o), U(null)), o instanceof Error && !(o.message in ge) && (ge[o.message] = !0, U(l), g("Failed %s type: %s", t, o.message), U(null));
          }
      }
    }
    var Qe = Array.isArray;
    function Z(e) {
      return Qe(e);
    }
    function er(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function rr(e) {
      try {
        return Ee(e), !1;
      } catch {
        return !0;
      }
    }
    function Ee(e) {
      return "" + e;
    }
    function Re(e) {
      if (rr(e))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", er(e)), Ee(e);
    }
    var be = P.ReactCurrentOwner, tr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, _e;
    function nr(e) {
      if (F.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function ar(e) {
      if (F.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function or(e, r) {
      typeof e.ref == "string" && be.current;
    }
    function ir(e, r) {
      {
        var t = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function sr(e, r) {
      {
        var t = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var ur = function(e, r, t, n, l, c, u) {
      var o = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: s,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: u,
        // Record the component responsible for creating this element.
        _owner: c
      };
      return o._store = {}, Object.defineProperty(o._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(o, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(o, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: l
      }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
    };
    function lr(e, r, t, n, l) {
      {
        var c, u = {}, o = null, y = null;
        t !== void 0 && (Re(t), o = "" + t), ar(r) && (Re(r.key), o = "" + r.key), nr(r) && (y = r.ref, or(r, l));
        for (c in r)
          F.call(r, c) && !tr.hasOwnProperty(c) && (u[c] = r[c]);
        if (e && e.defaultProps) {
          var d = e.defaultProps;
          for (c in d)
            u[c] === void 0 && (u[c] = d[c]);
        }
        if (o || y) {
          var v = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          o && ir(u, v), y && sr(u, v);
        }
        return ur(e, o, y, l, n, be.current, u);
      }
    }
    var Q = P.ReactCurrentOwner, je = P.ReactDebugCurrentFrame;
    function A(e) {
      if (e) {
        var r = e._owner, t = N(e.type, e._source, r ? r.type : null);
        je.setExtraStackFrame(t);
      } else
        je.setExtraStackFrame(null);
    }
    var ee;
    ee = !1;
    function re(e) {
      return typeof e == "object" && e !== null && e.$$typeof === s;
    }
    function we() {
      {
        if (Q.current) {
          var e = j(Q.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function cr(e) {
      return "";
    }
    var Te = {};
    function fr(e) {
      {
        var r = we();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Ce(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = fr(r);
        if (Te[t])
          return;
        Te[t] = !0;
        var n = "";
        e && e._owner && e._owner !== Q.current && (n = " It was passed a child from " + j(e._owner.type) + "."), A(e), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), A(null);
      }
    }
    function Se(e, r) {
      {
        if (typeof e != "object")
          return;
        if (Z(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            re(n) && Ce(n, r);
          }
        else if (re(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var l = $e(e);
          if (typeof l == "function" && l !== e.entries)
            for (var c = l.call(e), u; !(u = c.next()).done; )
              re(u.value) && Ce(u.value, r);
        }
      }
    }
    function dr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === _))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = j(r);
          Ze(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !ee) {
          ee = !0;
          var l = j(r);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", l || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function vr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            A(e), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), A(null);
            break;
          }
        }
        e.ref !== null && (A(e), g("Invalid attribute `ref` supplied to `React.Fragment`."), A(null));
      }
    }
    var ke = {};
    function Oe(e, r, t, n, l, c) {
      {
        var u = qe(e);
        if (!u) {
          var o = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var y = cr();
          y ? o += y : o += we();
          var d;
          e === null ? d = "null" : Z(e) ? d = "array" : e !== void 0 && e.$$typeof === s ? (d = "<" + (j(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : d = typeof e, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", d, o);
        }
        var v = lr(e, r, t, l, c);
        if (v == null)
          return v;
        if (u) {
          var x = r.children;
          if (x !== void 0)
            if (n)
              if (Z(x)) {
                for (var D = 0; D < x.length; D++)
                  Se(x[D], e);
                Object.freeze && Object.freeze(x);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Se(x, e);
        }
        if (F.call(r, "key")) {
          var k = j(e), E = Object.keys(r).filter(function(Er) {
            return Er !== "key";
          }), te = E.length > 0 ? "{key: someKey, " + E.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ke[k + te]) {
            var yr = E.length > 0 ? "{" + E.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, te, k, yr, k), ke[k + te] = !0;
          }
        }
        return e === p ? vr(v) : dr(v), v;
      }
    }
    function pr(e, r, t) {
      return Oe(e, r, t, !0);
    }
    function mr(e, r, t) {
      return Oe(e, r, t, !1);
    }
    var hr = mr, gr = pr;
    W.Fragment = p, W.jsx = hr, W.jsxs = gr;
  })()), W;
}
var De;
function Ir() {
  return De || (De = 1, process.env.NODE_ENV === "production" ? q.exports = Ar() : q.exports = Dr()), q.exports;
}
var i = Ir();
const ae = ({
  error: a,
  resetErrorBoundary: s
}) => {
  const { t: f } = Fe("error"), [p, m] = Rr(!1), b = jr();
  return /* @__PURE__ */ i.jsx(
    z,
    {
      sx: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2
      },
      children: /* @__PURE__ */ i.jsx(ne, { direction: "row", spacing: 4, alignItems: "center", width: "50%", children: /* @__PURE__ */ i.jsxs(ne, { spacing: 3, flex: 1, children: [
        /* @__PURE__ */ i.jsxs(Cr, { severity: "error", children: [
          /* @__PURE__ */ i.jsx(Sr, { children: f("에러가 발생했습니다") }),
          f("예상치 못한 문제가 발생했습니다. 잠시 후 다시 시도해주세요.")
        ] }),
        /* @__PURE__ */ i.jsx(kr, { in: p, children: /* @__PURE__ */ i.jsxs(
          z,
          {
            sx: {
              backgroundColor: "#f5f5f5",
              p: 2,
              borderRadius: 1,
              fontFamily: "monospace",
              whiteSpace: "pre-wrap",
              fontSize: "0.875rem",
              overflowX: "auto"
            },
            children: [
              /* @__PURE__ */ i.jsx(K, { variant: "subtitle2", children: f("에러 메시지:") }),
              a == null ? void 0 : a.message,
              /* @__PURE__ */ i.jsx(K, { variant: "subtitle2", sx: { mt: 2 }, children: f("에러 스택:") }),
              a == null ? void 0 : a.stack
            ]
          }
        ) }),
        /* @__PURE__ */ i.jsxs(ne, { direction: "row", spacing: 1, justifyContent: "flex-end", children: [
          /* @__PURE__ */ i.jsx(
            $,
            {
              variant: "outlined",
              onClick: () => m((w) => !w),
              children: f(p ? "에러 숨기기" : "자세히 보기")
            }
          ),
          /* @__PURE__ */ i.jsx(
            $,
            {
              variant: "contained",
              color: "primary",
              onClick: s,
              children: f("다시 시도")
            }
          ),
          /* @__PURE__ */ i.jsx(
            $,
            {
              variant: "text",
              onClick: () => b("/"),
              sx: { marginLeft: "auto" },
              children: f("홈으로")
            }
          )
        ] })
      ] }) })
    }
  );
}, Fr = ({ error: a }) => {
  const { t: s } = Fe("error"), p = Or().palette.mode, m = p === "dark" ? "#AEB3BE" : "#6c757d", b = p === "dark" ? "#E2E4E9" : "#343a40";
  return /* @__PURE__ */ i.jsxs(
    z,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 160px)"
      },
      children: [
        /* @__PURE__ */ i.jsxs(
          "svg",
          {
            width: "80",
            height: "80",
            viewBox: "0 0 80 80",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: { marginBottom: "1rem" },
            children: [
              /* @__PURE__ */ i.jsx("circle", { cx: "40", cy: "40", r: "30", stroke: m, strokeWidth: "4" }),
              /* @__PURE__ */ i.jsx(
                "line",
                {
                  x1: "28",
                  y1: "28",
                  x2: "52",
                  y2: "52",
                  stroke: m,
                  strokeWidth: "4",
                  strokeLinecap: "round"
                }
              ),
              /* @__PURE__ */ i.jsx(
                "line",
                {
                  x1: "52",
                  y1: "28",
                  x2: "28",
                  y2: "52",
                  stroke: m,
                  strokeWidth: "4",
                  strokeLinecap: "round"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ i.jsx(
          K,
          {
            variant: "h1",
            sx: {
              fontSize: "6rem",
              fontWeight: "bold",
              color: b,
              marginBottom: "1rem"
            },
            children: a.status ?? 404
          }
        ),
        /* @__PURE__ */ i.jsx(
          K,
          {
            sx: {
              fontSize: "1.5rem",
              color: m,
              marginBottom: "2rem"
            },
            children: a.statusText ?? s("페이지를 찾을 수 없습니다.")
          }
        ),
        /* @__PURE__ */ i.jsxs(z, { sx: { display: "flex", gap: "1rem" }, children: [
          /* @__PURE__ */ i.jsx(
            $,
            {
              onClick: () => window.history.back(),
              sx: {
                padding: "0.75rem 1.5rem",
                fontSize: "1rem",
                borderRadius: "0.5rem",
                backgroundColor: p === "dark" ? "#397CAC" : "#007bff",
                color: "white",
                transition: "0.2s"
              },
              children: s("이전 페이지")
            }
          ),
          /* @__PURE__ */ i.jsx(
            $,
            {
              onClick: () => window.location.href = "/",
              sx: {
                padding: "0.75rem 1.5rem",
                fontSize: "1rem",
                borderRadius: "0.5rem",
                backgroundColor: p === "dark" ? "#4B4F5A" : "#6c757d",
                color: "white",
                transition: "0.2s"
              },
              children: s("홈으로 가기")
            }
          )
        ] })
      ]
    }
  );
}, Kr = (a) => {
  const { children: s, onError: f, ...p } = a, m = (b) => {
    console.error(b);
  };
  return /* @__PURE__ */ i.jsx(
    _r,
    {
      FallbackComponent: ae,
      onError: f ?? m,
      ...p,
      children: s
    }
  );
}, J = "inbody:dynamic-import-reload", Lr = 1e4, Wr = [
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "Importing a module script failed",
  "ChunkLoadError"
], $r = (a) => a instanceof Error && Wr.some(
  (s) => a.message.includes(s)
), Le = () => `${window.location.pathname}${window.location.search}${window.location.hash}`, Yr = () => {
  try {
    const a = sessionStorage.getItem(
      J
    );
    if (!a)
      return null;
    const s = JSON.parse(a);
    return typeof s.pathname != "string" || typeof s.requestedAt != "number" ? (sessionStorage.removeItem(J), null) : {
      pathname: s.pathname,
      requestedAt: s.requestedAt
    };
  } catch {
    return sessionStorage.removeItem(J), null;
  }
}, Br = () => {
  const a = {
    pathname: Le(),
    requestedAt: Date.now()
  };
  sessionStorage.setItem(
    J,
    JSON.stringify(a)
  );
}, Mr = () => {
  const a = Yr();
  return !a || a.pathname !== Le() || Date.now() - a.requestedAt > Lr;
}, Gr = () => {
  const a = wr(), s = br(!1);
  if (xr(() => {
    $r(a) && !s.current && Mr() && (s.current = !0, Br(), window.location.reload());
  }, [a]), Tr(a))
    switch (a.status) {
      case 404:
        return /* @__PURE__ */ i.jsx(V, { fallback: /* @__PURE__ */ i.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ i.jsx(Fr, { error: a, resetErrorBoundary: () => {
        } }) });
      default:
        return /* @__PURE__ */ i.jsx(V, { fallback: /* @__PURE__ */ i.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ i.jsx(ae, { error: a, resetErrorBoundary: () => {
        } }) });
    }
  return a instanceof Error ? /* @__PURE__ */ i.jsx(V, { fallback: /* @__PURE__ */ i.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ i.jsx(ae, { error: a, resetErrorBoundary: () => {
  } }) }) : /* @__PURE__ */ i.jsx(V, { fallback: /* @__PURE__ */ i.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ i.jsx("div", { children: "Unknown Error Page" }) });
}, Hr = () => ({
  beforeError: [
    async (s) => {
      if (console.log("error Interceptor"), console.log(s), s instanceof Pr) {
        const { response: f } = s, p = s.message, m = f.headers.get("content-type"), b = m != null && m.includes("application/json") ? await f.clone().json().catch(() => null) : await f.clone().text().catch(() => null);
        console.error("[HTTP Error]", {
          url: f.url,
          status: f.status,
          body: b,
          message: p
        });
      } else typeof s == "object" && s !== null && "name" in s && s.name === "TimeoutError" ? console.error("[Timeout Error]", s.message) : console.error("[Unknown Error]", s);
      throw s;
    }
  ]
});
export {
  Kr as ErrorBoundaryProvider,
  ae as ErrorFallbackPage,
  Fr as NotFoundPage,
  Gr as RouteErrorBoundary,
  Hr as useApiErrorInterceptor
};
